
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/instagram-tracking-blog/[id]",
      function () {
        return require("private-next-pages/instagram-tracking-blog/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/instagram-tracking-blog/[id]"])
      });
    }
  